
export class LastPlayedSongDTO {
  constructor (songId, songTitle, artistName, artistImagePath) {
    this.songId = songId;
    this.songTitle = songTitle;
    this.artistName = artistName;
    this.artistImagePath = artistImagePath;
  }
}
